import * as React from 'react';
import { JoinPayload, SectionUIProps } from '~/common/types/types';
import { getValidClasses } from '~/helpers/helpers';
import {
  Button,
  FormattedMessage,
  SectionLayout,
} from '~/components/common/common';
import { JoinTheme } from './common/types/types';
import { themeToButtonColor } from './common/maps/maps';
import * as styles from './join.module.scss';

type Props = SectionUIProps & {
  payload: JoinPayload;
  theme?: JoinTheme;
  registrationLink: string | null;
};

const Join: React.FC<Props> = ({
  payload,
  sectionHighlight,
  registrationLink,
  theme = 'transparent',
}) => {
  const { title, description, postscript, registrationBtn } = payload;

  const hasRegistrationLink = Boolean(registrationLink);
  const isColored = theme !== 'transparent';
  const buttonColor = themeToButtonColor[theme];

  return (
    <SectionLayout
      classes={{
        wrapper: getValidClasses(styles[theme], isColored && styles.colored),
      }}
      sectionHighlight={sectionHighlight}
    >
      <div className={styles.content}>
        <h2 className={styles.title}>
          <FormattedMessage message={title} />
        </h2>
        <p className={styles.description}>
          <FormattedMessage message={description} />
        </p>
        {hasRegistrationLink ? (
          <Button
            gtm="sign_up"
            externalLink={registrationLink as string}
            withLanguageQuery
            btnColor={buttonColor}
            className={styles.button}
          >
            <FormattedMessage message={registrationBtn} />
          </Button>
        ) : (
          <p className={styles.postscript}>
            <FormattedMessage message={postscript} />
          </p>
        )}
      </div>
    </SectionLayout>
  );
};

export { Join };
